<template>
  <div>
    <el-dialog
      v-if="visible"
      :title="$l('btn_batch_generation') || '样品款号条码批量生成'"
      :show-close="true"
      :visible.sync="visible"
      width="760px"
      :close-on-click-modal="false"
      @close="close"
    >
      <div>
        <Main ref="main" @close="close" />
      </div>
      <div class="drawer-footer">
        <el-button type="close" size="small" @click="close">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('btn_confirm_generation') || '确认生成' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
  methods: {
    close({ flag = false } = {}) {
      this.$emit('update:visible', false)
      this.$emit('close', flag)
    },
  },
}
</script>
<style scoped>
.drawer-footer {
  padding: 40px 20px 15px 25px;
  display: flex;
  justify-content: flex-end;
}
</style>
